import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as navigationActions from "../../../actions/navigationActions";
import * as rccActions from "../../../actions/rccActions";
import * as componentTypes from "../../../constants/componentTypes";
import * as modelHelper from "../../../helpers/modelHelper";

import noImg from "../../../resources/img/no-image.png";
import imgPrint from "../../../resources/img/svgicons/print.svg";

import Button from "../generic/Button";
import CancelButton from "../generic/CancelButton";
import Modal from "../generic/Modal";

class PrintTaskPreviewModal extends Component {
    componentDidMount = () => {
        if (this.props.params && this.props.params.printParams) {
            this.props.dispatchGetPrintPreviewImageAction(
                this.props.params.printParams.template,
                this.props.params.printParams.values
            );
        }
    };

    handleCloseModalClick = () => {
        this.props.dispatchCloseModalAction();
    };

    handlePrintClick = () => {
        if (this.props.params && this.props.params.printParams) {
            this.props.dispatchStartPrintReportSilentAction(
                this.props.params.printParams.template,
                this.props.params.printParams.printerName,
                this.props.params.printParams.pages,
                this.props.params.printParams.values
            );
        }
    };

    getImageData = () => {
        if (this.props.params && this.props.params.printParams) {
            return window.imageStore.getPrintImageByName(this.props.params.printParams.template);
        }

        return null;
    };

    getPrinterImage = (printImage) => {
        if (printImage !== null) {
            return <img alt="preview" src={"data:" + printImage.type + ";base64," + printImage.img} />;
        }

        return <img alt="preview" src={noImg} />;
    };

    getPrintButton = (printImage) => {
        return (
            <Button
                onClick={this.handlePrintClick}
                svgBefore={imgPrint}
                label={<Translate value="general.print" />}
                disabled={
                    !this.props.connected || !this.props.params || !this.props.params.printParams || printImage === null
                }
            />
        );
    };

    render() {
        let printImage = this.getImageData();

        return (
            <Modal
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="general.print" />)}
                content={modelHelper.buildModalSection(
                    <div className="padding-15 fit-image margin-left-auto margin-right-auto text-center">
                        {this.getPrinterImage(printImage)}
                    </div>
                )}
                footer={modelHelper.buildModalSection(
                    <React.Fragment>
                        {this.getPrintButton(printImage)}
                        <CancelButton onClick={this.handleCloseModalClick} />
                    </React.Fragment>,
                    "flex-gap-10px"
                )}
                styles={{
                    width: "40%"
                }}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        connected: store.rcc.connected,
        imageStore: store.navigation.imageStore
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.PRINT_TASK_PREVIEW_MODAL));
        },
        dispatchGetPrintPreviewImageAction: (template, printValues) => {
            dispatch(rccActions.getPrintPreviewImage(null, template, printValues));
        },
        dispatchStartPrintReportSilentAction: (template, printer, pages, printValues) => {
            dispatch(rccActions.startPrintReportSilent(null, template, printer, pages, printValues));
        }
    };
};

export default PrintTaskPreviewModal = connect(mapStoreToProps, mapDispatchToProps)(PrintTaskPreviewModal);
